import React, { useEffect, useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import AdminLayout from './AdminLayout';
import supabase from '../../supabase/supabase';

const { FiSave, FiCheck, FiTruck } = FiIcons;

function AdminSettings() {
  const [agent, setAgent] = useState({ name: '', trackingUrl: '' });
  const [loading, setLoading] = useState(true);
  const [savingAgent, setSavingAgent] = useState(false);
  const [savedAgent, setSavedAgent] = useState(false);

  useEffect(() => {
    const load = async () => {
      const { data } = await supabase
        .from('settings_1750000003')
        .select('value')
        .eq('key', 'shipping_agent')
        .maybeSingle();

      if (data?.value) setAgent(data.value);
      setLoading(false);
    };
    load();
  }, []);

  const saveAgent = async () => {
    setSavingAgent(true);
    await supabase.from('settings_1750000003').upsert(
      { key: 'shipping_agent', value: agent, updated_at: new Date().toISOString() },
      { onConflict: 'key' }
    );
    setSavingAgent(false);
    setSavedAgent(true);
    setTimeout(() => setSavedAgent(false), 2500);
  };

  if (loading) return <AdminLayout><div className="admin-loading">Loading…</div></AdminLayout>;

  return (
    <AdminLayout>
      <div className="admin-page-header">
        <div><h1>Settings</h1><p>Manage your shipping agent and tracking link</p></div>
      </div>

      <div className="settings-grid">
        <div className="admin-card settings-card">
          <div className="settings-card-header">
            <div className="settings-icon" style={{ color: '#3b82f6', background: '#eff6ff' }}>
              <SafeIcon icon={FiTruck} />
            </div>
            <div>
              <h2>Shipping Agent</h2>
              <p className="settings-subtitle">Tracking link used when orders are picked up by driver</p>
            </div>
          </div>
          <div className="settings-fields">
            <div className="editor-field">
              <label>Agent Name</label>
              <input value={agent.name} onChange={(e) => setAgent((a) => ({ ...a, name: e.target.value }))} placeholder="e.g. DHL, FedEx" />
            </div>
            <div className="editor-field">
              <label>Tracking URL</label>
              <input value={agent.trackingUrl} onChange={(e) => setAgent((a) => ({ ...a, trackingUrl: e.target.value }))} placeholder="https://tracking-site.com/track?id=" />
              <small className="settings-hint">The tracking number will be appended to this URL</small>
            </div>
          </div>
          <div className="settings-actions">
            <button className="admin-btn primary" onClick={saveAgent} disabled={savingAgent}>
              {savedAgent ? <><SafeIcon icon={FiCheck} /> Saved!</> : savingAgent ? 'Saving…' : <><SafeIcon icon={FiSave} /> Save Shipping Agent</>}
            </button>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
}

export default AdminSettings;